<nav class="tabs">
  <a *ngFor="let t of tabs" [routerLink]="t.link" routerLinkActive="active">
    <i class="fa-solid" [ngClass]="t.icon"></i>
    <span>{{ t.label }}</span>
  </a>
</nav>
